module.exports = __webpack_public_path__ + "why14.webp?e65d1ca86c3408747e367cf80ff5f2eb";